// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6537":"4e58fd167ec646ad","7921":"ad0c2ac7c92b292b"}[chunkId] + ".css";
};